export default __webpack_public_path__ + "static/gallery-award-silver-d86ad95bd7ba7e125ed6af5a74ba881f.jpg";